module.exports = __webpack_public_path__ + "static/img/defaultPage.e0e265bd.png";